module.exports = __webpack_public_path__ + "img/tutorial1.6be01aa0.png";